import {
  CREATE_ADMIN,
  CREATE_ADMIN_FAIL,
  CREATE_ADMIN_SUCCESS,
  CREATE_USER,
  CREATE_USER_FAIL,
  CREATE_USER_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_FAIL,
  GET_CUSTOMERS_SUCCESS,
  SHOW_CREATE_MODAL,
  HIDE_CREATE_MODAL,
  SHOW_BULK_MODAL,
  HIDE_BULK_MODAL,
  SHOW_ADD_TAG_MODAL,
  HIDE_ADD_TAG_MODAL,
  ADD_TAGS,
  ADD_TAGS_SUCCESS,
  ADD_TAGS_FAILED,
  GET_USER_META_TAGS,
  GET_USER_META_TAGS_FAILED,
  GET_USER_META_TAGS_SUCCESS,
  RESET_USER_META_TAGS,
  UPDATE_CUSTOMER_DATA,
  UPDATE_CUSTOMER_DATA_FAILED,
  UPDATE_CUSTOMER_DATA_SUCCESS,
  SET_SELECTED_CUSTOMER,
  CONNECT_USER_TO_PRISM,
  CONNECT_USER_TO_PRISM_FAILED,
  CONNECT_USER_TO_PRISM_SUCCESS,
  REMOVE_USER_TAG,
  REMOVE_USER_TAG_FAILED,
  SHOW_REMOVE_USER_TAG_MODAL,
  HIDE_REMOVE_USER_TAG_MODAL,
  REMOVE_USER_TAG_SUCCESS,
  DELETE_PENDING_USERS,
  DELETE_PENDING_USERS_FAILED,
  DELETE_PENDING_USERS_SUCCESS,
  OPEN_DELETE_PENDING_USERS_MODAL,
  HIDE_DELETE_PENDING_USERS_MODAL,
  DELETE_USER,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  OPEN_DELETE_USER_MODAL,
  HIDE_DELETE_USER_MODAL,
  SET_USER_BLOCK_STATUS,
  SET_USER_BLOCK_STATUS_SUCCESS,
  SET_USER_BLOCK_STATUS_FAILED,
  OPEN_USER_BLOCK_STATUS_MODAL,
  HIDE_USER_BLOCK_STATUS_MODAL,
} from "./actionTypes"

const INIT_STATE = {
  customers: [],
  error: {},
  loading: false,
  current_page: 1,
  last_page: 1,
  total_items: 1,
  items_per_page: 25,
  from: 1,
  to: 1,
  isCreateModalOpen: false,
  isBulkModalOpen: false,
  isAddTagModalOpen: false,
  userMetaTags: [],
  selectedCustomer: null,
  removeUserTagModalIsOpen: false,
  deletePendingUsersModalIsOpen: false,
  deleteUserModalIsOpen: false,
  deleteUserIsLoading: false,
  setUserBlockStatusModalIsOpen: false,
  setUserBlockStatusIsLoading: false,
}

const Customers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMERS:
    case CREATE_USER:
    case CREATE_ADMIN:
    case ADD_TAGS:
    case GET_USER_META_TAGS:
    case UPDATE_CUSTOMER_DATA:
    case CONNECT_USER_TO_PRISM:
    case REMOVE_USER_TAG:
    case DELETE_PENDING_USERS:
      return {
        ...state,
        loading: true,
      }
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.data,
        current_page: action.payload.current_page,
        last_page: action.payload.last_page,
        total_items: action.payload.total,
        items_per_page: action.payload.per_page,
        from: action.payload.from,
        to: action.payload.to,
        loading: false,
      }

    case GET_CUSTOMERS_FAIL:
    case ADD_TAGS_FAILED:
    case GET_USER_META_TAGS_FAILED:
    case UPDATE_CUSTOMER_DATA_FAILED:
    case CONNECT_USER_TO_PRISM_FAILED:
    case REMOVE_USER_TAG_FAILED:
    case DELETE_PENDING_USERS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case CREATE_USER_SUCCESS:
    case CREATE_ADMIN_SUCCESS:
    case ADD_TAGS_SUCCESS:
    case CONNECT_USER_TO_PRISM_SUCCESS:
    case REMOVE_USER_TAG_SUCCESS:
    case DELETE_PENDING_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case CREATE_USER_FAIL:
    case CREATE_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case SHOW_CREATE_MODAL:
      return {
        ...state,
        isCreateModalOpen: true,
      }
    case HIDE_CREATE_MODAL:
      return {
        ...state,
        isCreateModalOpen: false,
      }
    case SHOW_BULK_MODAL:
      return {
        ...state,
        isBulkModalOpen: true,
      }
    case HIDE_BULK_MODAL:
      return {
        ...state,
        isBulkModalOpen: false,
      }
    case SHOW_ADD_TAG_MODAL:
      return {
        ...state,
        isAddTagModalOpen: true,
      }
    case HIDE_ADD_TAG_MODAL:
      return {
        ...state,
        isAddTagModalOpen: false,
      }
    case GET_USER_META_TAGS_SUCCESS:
      return {
        ...state,
        userMetaTags: action.payload,
        loading: false,
      }
    case RESET_USER_META_TAGS:
      return {
        ...state,
        userMetaTags: [],
      }
    case UPDATE_CUSTOMER_DATA_SUCCESS:
      return {
        ...state,
        selectedCustomer: action.payload,
        loading: false,
      }
    case SET_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
      }
    case SHOW_REMOVE_USER_TAG_MODAL:
      return {
        ...state,
        removeUserTagModalIsOpen: true,
      }
    case HIDE_REMOVE_USER_TAG_MODAL:
      return {
        ...state,
        removeUserTagModalIsOpen: false,
      }
    case OPEN_DELETE_PENDING_USERS_MODAL:
      return {
        ...state,
        deletePendingUsersModalIsOpen: true,
      }
    case HIDE_DELETE_PENDING_USERS_MODAL:
      return {
        ...state,
        deletePendingUsersModalIsOpen: false,
      }
    case DELETE_USER:
      return {
        ...state,
        deleteUserIsLoading: true,
      }
    case DELETE_USER_FAILED:
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUserIsLoading: false,
        deleteUserModalIsOpen: false,
      }
    case OPEN_DELETE_USER_MODAL:
      return {
        ...state,
        deleteUserModalIsOpen: true,
      }
    case HIDE_DELETE_USER_MODAL:
      return {
        ...state,
        deleteUserModalIsOpen: false,
      }
    case SET_USER_BLOCK_STATUS:
      return {
        ...state,
        setUserBlockStatusIsLoading: true,
      }
    case SET_USER_BLOCK_STATUS_SUCCESS:
    case SET_USER_BLOCK_STATUS_FAILED:
      return {
        ...state,
        setUserBlockStatusModalIsOpen: false,
        setUserBlockStatusIsLoading: false,
      }
    case OPEN_USER_BLOCK_STATUS_MODAL:
      return {
        ...state,
        setUserBlockStatusModalIsOpen: true,
      }
    case HIDE_USER_BLOCK_STATUS_MODAL:
      return {
        ...state,
        setUserBlockStatusModalIsOpen: false,
      }
    default:
      return state
  }
}

export default Customers
